/**
 * Marketing-team partners management makes a hard distinction between a real
 * contact email and a placeholder address generated during a data migration.
 * The placeholders always carry the synthetic suffix below — they MUST never
 * be rendered as-if-real in the UI (the team chases them up to collect a
 * real address). A single helper keeps that classification truth in one
 * place; the partner cell, future bulk-action filters, and the export pipe
 * all consult it instead of inlining the suffix check.
 */
const TEMP_EMAIL_SUFFIX = '@gtowizard.invalid'

export const isTempEmail = (email: string | null | undefined): boolean => {
  if (email == null) {
    return false
  }

  return email.toLowerCase().endsWith(TEMP_EMAIL_SUFFIX)
}
